import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { MenuComponent, MenuItem } from '@rocketfinancialcorp/rocket-ui/menu';

@Component({
  selector: 'app-add-financial-account-method-select',
  imports: [RktIconComponent, RktButtonDirective, MenuComponent],
  templateUrl: './add-financial-account-method-select.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class AddFinancialAccountMethodSelectComponent {
  @Input() disabled!: boolean;

  @Output() onboardAccountMethod = new EventEmitter<string>();

  addFinancialAccountMethods: MenuItem[] = [
    {
      label: 'Add Account Manually',
      command: () => this.addFinancialAccountMethod('MANUAL'),
      type: 'link',
    },
    {
      label: 'Connect External Account',
      command: () => this.addFinancialAccountMethod('EXTERNAL'),
      type: 'link',
    },
  ];

  addFinancialAccountMethod(onboardMethod: string) {
    this.onboardAccountMethod.emit(onboardMethod);
  }
}
